//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {UserMixin} from "~/node_modules/sitis-nuxt/lib/mixins";
import YandexMetricaMixin from "~/mixin/YandexMetricaMixin";
import {addToClipboard} from "~/helpers/clipboard";

export default {
  name: "StatisticsNumbers",
  mixins: [UserMixin, YandexMetricaMixin],
  data() {
    return {
      isLoading: false,
    };
  },

  computed: {
    getCurrency() {
      return this.$store.getters["currency/currentCurrency"];
    },
    dateFromTimestamp() {
      return new Date(this.created_at).toLocaleString('ru')
        .split(',')
        .join(' ');
    },
    phoneNumberWithPlus: function () {
      return this.$i18n.locale === 'ar' ? `${this.phoneNumber}+` : `+${this.phoneNumber}`;
    }
  },

  methods: {
    async onCopyToBuffer() {
      try {
        await addToClipboard(this.code);
        this.$toast.success(this.$t("copyToBuffer.success"));
      } catch (e) {
        this.$toast.success(this.$t("copyToBuffer.error"));
      }
    },
    async onBuyNumber() {
      if (!this.isLoggedIn) {
        this.$router.push(this.localePath("/registration?goback=1"));
        return null;
      }

      this.yandexGoalCheck('buy_query_statistics_attempt');
      this.yandexSendUserInfo({
        userId: this?.user?.id,
        userEmail: this?.user?.email
      })

      this.isLoading = true;
      let countryId = this.countryExternal_id;
      let numberId = this.serviceExternal_id;
      const newNumber = await this.$api.agent.transport
        .get(`sms-users/get-number/${countryId}/${numberId}`)
        .catch((err) => {
          let error = JSON.parse(err?.request?.response);
          this.$toast.error(error.message || "Error");
          this.isLoading = false;
        });
      if (!newNumber.data) {
        this.isLoading = false;
        return null;
      }
      if (this.$route.path !== "/profile") {
        this.$router.push(this.localePath("/profile"));
      }

      this.yandexGoalCheck('buy_query_statistics_success');
      this.yandexSendUserID({
        userId: this?.user?.id,
      })


      this.isLoading = false;
      this.$store.commit("active-numbers/updateIndex");
    },
  },
  props: {
    countryExternal_id: {
      type: String,
    },
    serviceExternal_id: {
      type: String,
    },
    price: {
      type: Number,
    },
    counrty_icon: {
      type: String,
    },
    code: {
      type: String,
    },
    serviceId: {
      type: Number,
    },
    timeStampOrder: {
      type: Number,
    },
    timestamp_end: {
      type: Number,
    },
    phoneNumber: {
      type: [String, Number],
    },
    serviceName: {
      type: String,
    },
    icon: {
      type: String,
    },
    end_at: {
      type: String,
    },
    created_at: {
      type: String,
    },
  },
};
